import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Contact from "../../../../../../screens/sharing/components/list-of-contacts/components/list-of-contacts-body/components/list-of-contacts-body-content/components/contact/index";
import Icon from "../../../../../icon/index";
import './index.css';
import Button from "../../../../../button";
import {
    confirmContactResearch, isSearchResultsDropDownShown as setIsSearchResultsDropDownShown,
    isSearchResultsDropDownShown
} from "../../../../../../../actions/contactActions";

function ContactsResult () {

    const { t } = useTranslation();

	const contactSearchResult = useSelector(state => state.contactReducer.contactSearchResult);
	const isSearchingContacts = useSelector(state => state.contactReducer.isSearchingContacts);

    const dispatch = useDispatch();

    const handleConfirmSearch = () => {
        dispatch(confirmContactResearch(true));
        dispatch(setIsSearchResultsDropDownShown(false));
    }

    return (
        <div className="contacts-result">
            <div className="m-3 text-right">
                <Button className='btn-link close mr-1 p-0' onClick={() => dispatch(isSearchResultsDropDownShown(false))}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fill="currentColor"
                              d="m2.74,23.59l-2.32,-2.32l9.27,-9.27l-9.27,-9.27l2.32,-2.32l9.27,9.27l9.27,-9.27l2.32,2.32l-9.27,9.27l9.27,9.27l-2.32,2.32l-9.27,-9.27l-9.27,9.27z"
                              id="svg_1"/>
                    </svg>
                </Button>
            </div>

            <div className="contacts-result__content">
                {
                    isSearchingContacts === false
                        ?
                        contactSearchResult.contacts.length > 0
                            ?
                            contactSearchResult.contacts.map((item) => (
                                <Contact
                                    key={item.id}
                                    id={item.id}
                                    name={item.name}
                                    email={item.email}
                                    emails={item.emails}
                                    hasImage={item.hasImage}
                                    picture={item.picture}
                                    phoneNumber={item.phoneNumber}
                                    jobTitle={item.jobTitle}
                                    company={item.company}
                                    labels={item.groups}
                                    type={item.type}
                                    fromAutocomplete={true}
                                    shareable={item.shareable}
                                    editable={item.editable}
                                    deletable={item.deletable}
                                    searchResults={true}
                                    totalComments={item.totalComments}
                                />
                            ))
                            :
                            <div className="p-3">
                                {t("noContactText")}.
                            </div>
                        :
                        <div className="p-3">
                            <Icon animated={'pulse'} name="spinner"/>
                        </div>
                }
            </div>
            <div className="text-right p-3">
                <Button className="btn-outline-secondary mr-3" onClick={() => dispatch(isSearchResultsDropDownShown(false))}>
	                {t('closeBtn')}
                </Button>
                <Button className="btn-primary" onClick={ handleConfirmSearch }>
                    {t('displayResultsBtn')}
                </Button>
            </div>
        </div>

    );
}

export default ContactsResult;
